<template>
  <v-card class="mt-4 mx-auto">
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="success"
      elevation="12"
      max-width="calc(100% - 32px)"
    >
      <v-card
        dark
        color="color_green"
      >
        <v-card-title> LAYERS </v-card-title>
      </v-card>
    </v-sheet>
    <v-card-text class="pt-0">
      <v-data-table
        id="layer-table"
        :headers="layers.headers"
        :items="layers.layers"
        :search="search"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-toolbar>
        </template>
        <template v-slot:[`item.tier`]="{ item }">
          <v-btn-toggle
            :value="item.tier"
            mandatory
            dense
            color="color_green"
            @change="tier => changeTier(item, tier)"
          >
            <v-btn
              small
              value="base"
            >
              Base
            </v-btn>
            <v-btn
              small
              value="avanzata"
            >
              Avanzata
            </v-btn>
          </v-btn-toggle>
        </template>
        <template v-slot:no-data>
          <span color="primary">No data to show you</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      search: '',
      loading: false
    };
  },
  computed: {
    ...mapState(['layers'])
  },

  async created() {
    this.loading = true;
    await this.storeAllLayers();
    this.loading = false;
  },

  methods: {
    ...mapActions(['storeAllLayers', 'storeLayerTier']),
    async changeTier(item, tier) {
      if (!tier || tier === item.tier) {
        return;
      }

      await this.storeLayerTier({ layer_name: item.layer_name, tier });
    }
  }
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
